import { FindOneSyncQuery, SyncListItemFragment } from "@/apollo/types";
import Tooltip from "@/components/elements/Tooltip";
import { IntegrationLogoBox } from "@/integrations";
import { ChevronRightIcon } from "@heroicons/react/16/solid";

export function ConnectorCell(props: { rEltSync: SyncListItemFragment }) {
  return (
    <div className="flex items-center space-x-2">
      <IntegrationLogoBox
        id={props.rEltSync.destinationIntegrationId}
        size="xs"
      />
      <div className="flex max-w-lg flex-col">
        <div className="flex items-center space-x-1 whitespace-nowrap">
          <MainLabel rEltSync={props.rEltSync} />
        </div>
      </div>
    </div>
  );
}

const MainLabel = (props: {
  rEltSync: SyncListItemFragment | FindOneSyncQuery["findOneSync"];
}) => {
  const connectionLabel =
    props.rEltSync.destinationConnection.label ||
    props.rEltSync.destinationIntegrationId;
  if (props.rEltSync.destinationIntegrationId.includes("google-sheets")) {
    const text = `${props.rEltSync.config?.destinationSettings?.spreadsheet?.label} > ${props.rEltSync.config?.destinationSettings?.sheet?.label}`;
    const tooltip = `${text} (${props.rEltSync.config?.destinationSettings?.spreadsheet?.label} > ${props.rEltSync.config?.destinationSettings?.sheet?.label})`;
    return (
      <Tooltip content={tooltip}>
        <div className="flex min-w-0 items-center gap-0.5 truncate">
          <span className="truncate">
            {props.rEltSync.config?.destinationSettings?.spreadsheet?.label}
          </span>
          <ChevronRightIcon className="h-4 w-4 shrink-0" />
          <span className="truncate">
            {props.rEltSync.config?.destinationSettings?.sheet?.label}
          </span>
        </div>
      </Tooltip>
    );
  }
  const tooltip = `${props.rEltSync.primaryObject} (${connectionLabel})`;
  return (
    <Tooltip content={tooltip}>
      <div>{props.rEltSync.primaryObject}</div>
    </Tooltip>
  );
};
